export default "__VITE_ASSET__C$NRj_s7__"